// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_iy-0";